import { useState, useEffect, useContext } from "react";
import { loaderContext } from "../contexts/LoaderProvider";
import ProcessData from "./ProcessData";

const PasswordField = ({ data, setData, errors, setErrors, field, value }) => {
  const [showPassword, setShowPassword] = useState(false);
  const { isLoading } = useContext(loaderContext);

  useEffect(() => {
    setShowPassword(false);
  }, [isLoading]);
  return (
    <>
      <div className="position-relative">
        <input
          type={showPassword ? `text` : `password`}
          className="form-control create-password-input"
          placeholder="password"
          autoComplete="off"
          value={value}
          onChange={(e) => {
            ProcessData(data, setData, e, "string", field, errors, setErrors);
          }}
        />
        <span
          onClick={() => {
            setShowPassword(!showPassword);
          }}
          className="show-password-button text-muted"
          id="button-addon2"
        >
          <i
            className={
              showPassword
                ? `ri-eye-line align-middle`
                : `ri-eye-off-line align-middle`
            }
          ></i>
        </span>
      </div>
      <small className="text-danger">{errors?.password ?? ""}</small>
    </>
  );
};

export default PasswordField;
